import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import { Alert, Box, LinearProgress, Skeleton, Stack } from "@mui/material";
import { fetchIndicatorApi } from "../../../../Utilities/Url";
import { utils, writeFile } from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import { canExportToCSV } from "../config";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const EmaTable = () => {
  const [sortColumn, setSortColumn] = useState("symbols");
  const [sortDirection, setSortDirection] = useState("asc");
  const EMA = useSelector((state) => state.EmaData);
  const rowsPerPage = useSelector((state) => state.RowsPerPage);
  const page = useSelector((state) => state.SetPage);
  const searchItem = useSelector((state) => state.SearchItems);
  const SetError = useSelector((state) => state.SetError);
  const tableTickerName = useSelector((state) => state.TickerName);
  const SelectedDropdownOption = useSelector(
    (state) => state.SelectedDropdownOption
  );
  const setActiveButton = useSelector((state) => state.ActiveButton);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const isLoading = useSelector((state) => state.isLoading);
  const authToken = useSelector((state) => state.authToken);
  const selectedAnalytics = useSelector((state) => state.selectedAnalytics);

  const dispatch = useDispatch();
  useEffect(() => {
    if (SelectedDropdownOption === "EMA") {
      fetchIndicatorApi(
        selectedExchange,
        setActiveButton,
        SelectedDropdownOption,
        dispatch,
        authToken,
        selectedAnalytics
      );
    }

    // if(SelectedDropdownOption === 'EMA' ){
    //   const token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTQzODg5NTIsImV4cCI6MTcxNDQ3NTM1MiwiaWF0IjoxNzE0Mzg4OTUyfQ.KgeibbxuX-bGdwTgk2xqC80vuiL4QZjsctR9-l6gTQg";
    // const tokenforIntraday =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTY1MzE0NTksImV4cCI6MTcxNjYxNzg1OSwiaWF0IjoxNzE2NTMxNDU5fQ.yw2Eg4p36-Td3S38gjmthcXdS_VtumZ_9l309ccQ1jA";
    //  const fetchEMAApi = async () => {

    //   try {
    //     let timeframeToken;
    //     let position;
    //     if (
    //       setActiveButton === "OneMinute" ||
    //       setActiveButton === "FiveMinute" ||
    //       setActiveButton === "FifteenMinute" ||
    //       setActiveButton === "ThirtyMinute" ||
    //       setActiveButton === "OneHour"
    //     ) {
    //       timeframeToken = tokenforIntraday;
    //       position = "intradayanalytics";
    //     } else {
    //       timeframeToken = token;
    //       position = "eodanalytics";
    //     }

    //     const IndicatorApi = `https://idart.ftconline.in/api/${position}/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${setActiveButton}`;
    //     const response = await fetch(IndicatorApi, {
    //       headers: { Authorization: `Bearer ${timeframeToken}` },
    //     });
    //     let data = await response.json();
    //     if (response.ok  ){
    //       dispatch({type:"TICKER_NAME",payload:data.Data});
    //       dispatch({ type: "SET_ERROR", payload: null });
    //       // dispatch({ type: "IS_LOADING", payload: false });

    //     }
    //   } catch (error) {
    //     console.error(error);
    //     dispatch({ type: "SET_ERROR", payload: "Error in Api" });
    //     // dispatch({ type: "IS_LOADING", payload: false });
    //   }
    // };
    // fetchEMAApi()
    // }
  }, [selectedExchange, setActiveButton, SelectedDropdownOption]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#ebebeb",
      color: theme.palette.common.black,
      borderRight: `1px solid ${theme.palette.divider}`,
      textAlign: "center",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: theme.spacing(1),
      borderRight: `1px solid ${theme.palette.divider}`,
      padding: "4px 8px",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      // backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    fontWeight: "normal",
  }));
  const rowsPerPageOptions = [5, 10, 25];
  const handleChangePage = (event, newPage) => {
    dispatch({ type: "SET_PAGE", payload: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: "ROWS_PER_PAGE",
      payload: parseInt(event.target.value, 10),
    });
    dispatch({ type: "SET_PAGE", payload: 0 });
  };

  const handleFirstPageButtonClick = (event) => {
    handleChangePage(event, 0);
  };

  const handleLastPageButtonClick = (event, count) => {
    handleChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;

    return (
      <div style={{ flexShrink: 0, marginLeft: "2.5em" }}>
        <IconButton
          onClick={(event) => onPageChange(event, 0)}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={(event) => onPageChange(event, page - 1)}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={(event) => onPageChange(event, page + 1)}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={(event) => handleLastPageButtonClick(event, count)}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  };

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection((prevDirection) =>
        prevDirection === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const handleExportCSV = () => {
    // Create headers for the CSV file
    const headers = [
      "Ticker",
      "EMA5",
      "EMA8",
      "EMA10",
      "EMA20",
      "EMA50",
      "EMA100",
      "EMA200",
      "STRENGTH",
      "OVERALL",
    ];

    // Map data to rows for the CSV file
    const csvData = (
      tableTickerName &&
      (tableTickerName[0] || tableTickerName)
    ).map((item, index) => {
      // Check if EMAResults is valid
      const getEMAValue = (indicator) =>
        item.EMAResults && Array.isArray(item.EMAResults)
          ? item.EMAResults.find(
              (ind) => ind.Indicator === indicator
            )?.Value?.toFixed(2) || ""
          : "";

      const EMA5 = getEMAValue("EMA5");
      const EMA8 = getEMAValue("EMA8");
      const EMA10 = getEMAValue("EMA10");
      const EMA20 = getEMAValue("EMA20");
      const EMA50 = getEMAValue("EMA50");
      const EMA100 = getEMAValue("EMA100");
      const EMA200 = getEMAValue("EMA200");

      return [
        item.Ticker || "", // Handle case if Ticker is undefined
        EMA5,
        EMA8,
        EMA10,
        EMA20,
        EMA50,
        EMA100,
        EMA200,
        (item.EMASummary?.SummaryPercent || "") + "%", // Add '%' to STRENGTH
        (item.Overall?.SummaryPercent || "") + "%", // Add '%' to OVERALL
      ];
    });

    // Combine headers and data
    const data = [headers, ...csvData];

    // Convert CSV data to worksheet
    const ws = utils.aoa_to_sheet(data);

    // Create a new workbook and add the worksheet
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "EMAData");

    // Write the workbook to a file
    writeFile(wb, "EMAData.xlsx"); // Change the file name as needed
  };

  let filterTicker = (
    tableTickerName &&
    (tableTickerName[0] || tableTickerName)
  ).filter((ele) => ele.Ticker.includes(searchItem[searchItem.length - 1]));
  return SetError === null ? (
    <div>
      {isLoading ? (
        <Stack spacing={1} padding={"5px"}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={50}
            animation="wave"
          />
          <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
            <Skeleton
              variant="rectangular"
              width={300}
              height={100}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width={300}
              height={100}
              animation="wave"
            />
          </div>
        </Stack>
      ) : (
        <TableContainer sx={{ maxHeight: 365 }}>
          {canExportToCSV && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                padding: "6px",
                cursor: "pointer",
              }}
            >
              <DownloadIcon
                onClick={handleExportCSV}
                aria-label="export to CSV"
              />
            </div>
          )}
          <Table stickyHeader aria-label="customized table" size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("symbols")}
                  >
                    SYMBOLS
                    {sortColumn === "symbols" && sortDirection === "asc" ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowUpIcon />
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA5
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA8
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA10
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA20
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA50
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA100
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  EMA200
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  STRENGTH
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("overall")}
                  >
                    OVERALL
                    {sortColumn === "overall" && sortDirection === "asc" ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowUpIcon />
                    )}
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchItem.length !== 0 && filterTicker.length === 0 ? (
                <TableRow>
                  <StyledTableCell colSpan={10} align="center">
                    NO DATA FOUND
                  </StyledTableCell>
                </TableRow>
              ) : (
                (filterTicker.length === 0
                  ? tableTickerName && (tableTickerName[0] || tableTickerName)
                  : filterTicker
                )
                  ?.sort((a, b) => {
                    if (sortColumn === "symbols") {
                      return sortDirection === "asc"
                        ? a.Ticker.localeCompare(b.Ticker)
                        : b.Ticker.localeCompare(a.Ticker);
                    } else if (sortColumn === "overall") {
                      const comparison =
                        b.Overall.SummaryPercent - a.Overall.SummaryPercent;
                      return sortDirection === "asc" ? comparison : -comparison;
                    }
                    return 0;
                  })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index, arr) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell sx={{ textAlign: "left" }}>
                        {item.Ticker}
                      </StyledTableCell>
                      {item.EMAResults.map((emaResult, emaIndex) => (
                        <StyledTableCell
                          key={emaIndex}
                          sx={{ textAlign: "right" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginLeft: "15px",
                            }}
                          >
                            <div
                              style={{
                                height: "10px",
                                width: "10px",
                                backgroundColor: getColor(emaResult.Indication),
                                borderRadius: "100%",
                              }}
                            ></div>
                            {emaResult.Value?.toFixed(2)}
                          </div>
                        </StyledTableCell>
                      ))}
                      <StyledTableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginLeft: "15px",
                          }}
                        >
                          <div
                            style={{
                              height: "10px",
                              width: "10px",
                              backgroundColor: getColor(
                                item.EMASummary.Summary
                              ),
                              borderRadius: "100%",
                            }}
                          ></div>
                          {item.EMASummary.SummaryPercent?.toFixed(2)}%
                        </div>
                      </StyledTableCell>
                      <StyledTableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginLeft: "15px",
                          }}
                        >
                          <div
                            style={{
                              height: "10px",
                              width: "10px",
                              backgroundColor: getColor(item.Overall.Summary),
                              borderRadius: "100%",
                            }}
                          ></div>
                          {item.Overall.SummaryPercent?.toFixed(2)}%
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!(searchItem.length !== 0 && filterTicker.length === 0) &&
        !isLoading && (
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={
              filterTicker.length === 0
                ? (tableTickerName && (tableTickerName[0] || tableTickerName))
                    .length || 0
                : filterTicker.length || 0
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        )}
    </div>
  ) : (
    // <h3>The API request encountered an error and failed to retrieve the desired data.</h3>
    // <Alert severity="error">The API request encountered an error and failed to retrieve the desired data.</Alert>
    <Alert severity="error">{SetError}</Alert>
  );
};

export default EmaTable;

const getColor = (indication) => {
  switch (indication) {
    case "StrongBuy":
      return "#43a047";
    case "Buy":
      return "#81c784";
    case "OverBought":
      return "#1b5e20";
    case "Sell":
      return "#ef5350";
    case "StrongSell":
      return "#d32f2f";
    case "OverSold":
      return "#b71c1c";
    case "Neutral":
      return "#cfd8dc";
    default:
      return "#000000";
  }
};
